module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="assignmentContainer">\n';
 for (var i = 0; i < assignments.length; i++){ ;
__p += '\n    ';
 var categoryIndex = i ;
__p += '\n    <div id = ' +
((__t = ( i )) == null ? '' : __t) +
' class = "branch collapsed">\n      <span class="glyphicon glyphicon-chevron-right"></span>\n      <span class = "groupLabel">\n          ' +
((__t = ( assignments[categoryIndex].category )) == null ? '' : __t) +
'\n          <span class = "assignmentCount">\n            ' +
((__t = ( "("+assignments[categoryIndex].assignments.length+")" )) == null ? '' : __t) +
'\n          </span>\n      </span>\n    </div>\n    <div id = ' +
((__t = ( "assignmentGroup"+i )) == null ? '' : __t) +
' style = "display:none;">\n      ';
 for (var j = 0; j < assignments[categoryIndex].assignments.length; j++){ ;
__p += '\n          ';
 var assignmentIndex = j ;
__p += '\n        <div class = "assignmentPreview">\n        ';
 var assignment = assignments[categoryIndex].assignments[assignmentIndex]; ;
__p += '\n          <span class = "asssignmentLabel">\n            <div class = "assignmentLabelName">\n              ' +
((__t = ( assignment.name )) == null ? '' : __t) +
'\n            </div>\n            <div class = "assignmentLabelDescription">\n              ' +
((__t = ( assignment.description )) == null ? '' : __t) +
'\n            </div>\n            <div class = "assignmentLabelAuthor">\n              ' +
((__t = (terms.authors[language])) == null ? '' : __t) +
': ' +
((__t = ( assignment.author )) == null ? '' : __t) +
'\n            </div>\n          </span>\n          <span class = "selectAssignment btn btn-default" id = ' +
((__t = ( assignment.path )) == null ? '' : __t) +
'>\n            <span class="glyphicon glyphicon-arrow-right"></span>\n          </span>\n        </div>\n      ';
 } ;
__p += '\n    </div>\n  ';
 } ;
__p += '\n</div>';

}
return __p
}